import { Button } from "react-bootstrap"
import { ShowMedia } from "./AddMedia"
import { shorten } from "./helpers"


/**
 * Display the report information
 */
export default function ReportInfo({ report }) {
  if (!report) return null

  return (
    <div>
      <div style={{ marginBottom: 15 }}>
        <h4 className="trubbl-color" style={{ marginBottom: 0 }}>Subject:</h4>
        {report.subject}
        {!report.details ? null : <>
          <h4 className="trubbl-color" style={{ marginBottom: 0, marginTop: 15 }}>Details:</h4>
          {shorten(report.details, 90)}
        </>}
        <ShowMedia media={report.media} />
      </div>
      <Button
        variant="link"
        onClick={() => window.open("https://trubbl.com/report/" + report._id, '_blank')}
        className="p-0 align-baseline"
      >
        See your report on Trubbl.com
      </Button>
    </div>
  )
}
